/* eslint-disable simple-import-sort/exports */

import { installContentDeliveryClient } from './utils/install-content-delivery-client';

// Overlay for CMS_DELIVERY_API_BASE_URL. Do not patch generated/core/request.ts — see README.md.
installContentDeliveryClient();

export * from './generated/index';
export { ContentService } from './services/content-service';
export { MediaService } from './services/media-service';

export * from './utils/index';
